export class Counts {
  constructor(private totalNotifications: number, private unreadNotifications: number) {}

  getTotal(): number {
    return this.totalNotifications;
  }

  getUnread(): number {
    return this.unreadNotifications;
  }

  setTotal(value: number) {
    this.totalNotifications = value;
  }

  setUnread(value: number) {
    this.unreadNotifications = value;
  }
}
